"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleIconWrapper = exports.MainContent = exports.CompanyInfoSectionWrapper = exports.InfoColumn = exports.GalleryColumn = exports.MainContentColumns = exports.StyledPlusOutlined = exports.AddPrimaryGalleryWrapper = exports.AddPrimaryGalleryButton = exports.CompanyInfoDetail = exports.FullHeightVerticalSeparator = exports.InfoFieldValue = exports.FlexAboutCompanyText = exports.FlexPrimaryImage = exports.AboutCompanyTitle = exports.CompanyAbout = exports.CompanyInfo = exports.EditButton = exports.StyledUserOutlined = exports.StyledCinIcon = exports.StyledAreaIcon = exports.TitleWrapper = exports.PrimaryGalleryOverlay = exports.ClickAssetWrapper = exports.DetailVideoIcon = exports.DetailIcon = exports.EmptyPrimaryImageWrapper = exports.AssetImg = void 0;
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const streamlinehq_briefcase_business_products_svg_1 = __importDefault(require("@public/media/icons/streamlinehq-briefcase-business-products.svg"));
const streamlinehq_real_estate_action_building_information_real_estate_svg_1 = __importDefault(require("@public/media/icons/streamlinehq-real-estate-action-building-information-real-estate.svg"));
const streamlinehq_single_neutral_users_svg_1 = __importDefault(require("@public/media/icons/streamlinehq-single-neutral-users.svg"));
const icons_1 = require("@ant-design/icons");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.AssetImg = styled_components_1.default.img `
	width: 100%;
	height: 250px;
	object-fit: cover;

	${(0, styled_breakpoints_1.up)('sm')} {
		max-height: 550px;
		height: 100%;
	}
`;
exports.EmptyPrimaryImageWrapper = styled_components_1.default.div `
	position: relative;
`;
exports.DetailIcon = (0, styled_components_1.default)(icons_1.EyeOutlined) `
	width: 3rem;
	height: 3rem;
	padding: 1rem;
	border-radius: 4rem;
	background: rgb(80, 80, 80);
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0;
	transition: 0.3s;
	transform: scale(0.5);

	svg {
		height: 100%;
		width: 100%;
	}
`;
exports.DetailVideoIcon = (0, styled_components_1.default)(icons_1.PlayCircleOutlined) `
	width: 3rem;
	height: 3rem;
	padding: 0.75rem;
	border-radius: 4rem;
	background: rgb(80, 80, 80);
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0;
	transition: 0.3s;
	transform: scale(0.5);

	svg {
		height: 100%;
		width: 100%;
	}
`;
exports.ClickAssetWrapper = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	position: relative;
	cursor: pointer;
`;
exports.PrimaryGalleryOverlay = styled_components_1.default.div `
	top: 0;
	position: absolute;
	color: ${props => props.theme.color.white};
	width: 100%;
	height: 100%;
	display: flex;
	font-size: ${props => props.theme.fontSizes.m};
	flex-direction: column;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	z-index: 1;
	background: rgba(0, 0, 0, 0);
	transition: 0.3s;

	&:hover {
		background: rgba(0, 0, 0, 0.2);

		${exports.DetailIcon} {
			opacity: 1;
			transform: scale(1);
		}

		${exports.DetailVideoIcon} {
			opacity: 1;
			transform: scale(1);
		}
	}
`;
exports.TitleWrapper = styled_components_1.default.div `
	color: ${props => props.theme.color.brand3};
	font-weight: bold;
`;
exports.StyledAreaIcon = (0, styled_components_1.default)(streamlinehq_briefcase_business_products_svg_1.default) `
	width: 1.25rem;
	height: 1.25rem;
	color: ${props => props.theme.color.brand1};
`;
exports.StyledCinIcon = (0, styled_components_1.default)(streamlinehq_real_estate_action_building_information_real_estate_svg_1.default) `
	width: 1.25rem;
	height: 1.25rem;
	color: ${props => props.theme.color.brand1};
`;
exports.StyledUserOutlined = (0, styled_components_1.default)(streamlinehq_single_neutral_users_svg_1.default) `
	width: 1.25rem;
	height: 1.25rem;
	color: ${props => props.theme.color.brand1};
`;
exports.EditButton = (0, styled_components_1.default)(elements_1.Button) `
	color: ${props => props.theme.color.brand1};
	border: 1px solid ${({ theme }) => theme.color.brand1};
	justify-content: end;
	:hover {
		background-color: ${props => (0, polished_1.darken)(0.1, props.theme.color.white)};
	}
`;
exports.CompanyInfo = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	flex-direction: column;
	padding: 0 1rem;
`;
exports.CompanyAbout = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 1rem;
	margin-bottom: 1rem;
	border: 1px solid ${({ theme }) => theme.color.gray4};

	${(0, styled_breakpoints_1.up)('md')} {
		flex-direction: row;
	}
`;
exports.AboutCompanyTitle = styled_components_1.default.div `
	color: ${props => props.theme.color.brand3};
	font-size: 1.25rem;
	font-weight: bold;
	margin-bottom: 1rem;
	text-align: center;
`;
exports.FlexPrimaryImage = styled_components_1.default.div `
	width: 100%;
	margin: auto;
	${(0, styled_breakpoints_1.up)('md')} {
		width: unset;
	}
`;
exports.FlexAboutCompanyText = styled_components_1.default.div `
	flex: 1 1 0;
`;
exports.InfoFieldValue = styled_components_1.default.div ``;
exports.FullHeightVerticalSeparator = (0, styled_components_1.default)(elements_1.Separator) `
	height: 100%;
`;
exports.CompanyInfoDetail = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	${(0, styled_breakpoints_1.up)('md')} {
		justify-content: unset;
	}
`;
exports.AddPrimaryGalleryButton = (0, styled_components_1.default)(elements_1.Button) `
	width: 250px;
	height: 125px;
	margin: 1rem;
	font-size: 1.25rem;
	background: url('/media/images/background-gradient.jpg') 50% 50%;
	border: 1px solid transparent;

	&:hover {
		background: url('/media/images/background-gradient.jpg') 50% 0%;
	}
`;
exports.AddPrimaryGalleryWrapper = styled_components_1.default.div `
	border: ${({ theme, hasPrimaryAsset }) => (!hasPrimaryAsset ? `1px solid ${theme.color.gray4}` : 'none')};
	z-index: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 500px;
	flex: 1 1 0;
`;
exports.StyledPlusOutlined = (0, styled_components_1.default)(icons_1.PlusOutlined) `
	svg {
		width: 2rem;
		height: 2rem;
	}
`;
exports.MainContentColumns = styled_components_1.default.div `
	padding: 1rem 1rem 0 1rem;
	gap: 1rem;
	${(0, styled_breakpoints_1.up)('md')} {
		display: flex;
	}
`;
exports.GalleryColumn = styled_components_1.default.div `
	display: ${({ shouldStretchTheCompanyInfo }) => (shouldStretchTheCompanyInfo ? 'none' : '')};
	${(0, styled_breakpoints_1.up)('md')} {
		flex: 3;
	}
`;
exports.InfoColumn = styled_components_1.default.div `
	${(0, styled_breakpoints_1.up)('md')} {
		flex: 1;
	}
`;
exports.CompanyInfoSectionWrapper = styled_components_1.default.div `
	display: flex;
	margin-bottom: 0.75rem;
	flex-direction: row;
`;
exports.MainContent = styled_components_1.default.div `
	max-width: ${({ theme }) => theme.breakpoints.xl};
	margin: auto;
	padding-bottom: 1rem;
`;
exports.CircleIconWrapper = styled_components_1.default.div `
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 0.5rem 0 0;
	border: 1px solid ${({ theme }) => theme.color.brand1};
	width: 2rem;
	height: 2rem;
	min-width: 2rem;
`;
